import React, { Component } from 'react'

class Checkboxlist extends Component {
    constructor(props) {
        super(props)

        this.state = {
            keyword: ''
        };
    }

    onChange(values, item, checked) {
        const index = values.findIndex(x => x === item.value);

        if (checked) {
            if (this.props.isOnceChoice) {
                values = [item.value];
            } else {
                //need add to array
                if (index === -1) {
                    values = values.concat(item.value);
                }
            }
        } else {
            //need remove from array
            if (index > -1) {
                values.splice(index, 1);
            }
        }

        this.props.onChange(values);
    }

    onAllChange = (checked) => {
        let values = [];
        if (checked) {
            values = this.getPptions(this.props.options).map((item) => { return item.value; });
        }

        this.props.onChange(values);
    }

    shouldChecked = (value, values) => {
        if (!values || values.length === 0) {
            return false;
        }
        let index = values.findIndex(x => x === value);

        return index > -1;
    }

    searchTextChanged = (e) => {
        this.setState({ keyword: e.target.value })
    }

    getPptions = (options) => {
        options = options || [];
        let { keyword } = this.state;
        if (keyword && keyword.trim() != '') {
            keyword = keyword.toLowerCase();

            return options.filter((item) => {
                return item.label.toLowerCase().indexOf(keyword) > -1;
            })
        }

        return options;
    }

    render() {


        const values = this.props.values || [];
        const className = this.props.className || "";

        return (
            <div className={`list-group-item form-group checkbox-list ${className}`}>
                {this.props.enableSearchBox && (
                    <div className="search">
                        <input placeholder={"Tìm kiếm..."} className="form-control" type="search" onChange={(e) => this.searchTextChanged(e)} />
                    </div>
                )}
                {!this.props.isOnceChoice && (
                    <div className="checkbox">
                        <label className="checkcustom mt-2 mb-1">
                            <input
                                onChange={(e) => this.onAllChange(e.target.checked)}
                                type={'checkbox'}
                            />
                            {'\u00A0'}{"Tất cả"}
                            <span className="checkmark"></span>
                        </label>
                    </div>
                )}
                <div className="checkbox-list-items">
                    {this.getPptions(this.props.options).map((item) => (
                        <div className="checkbox" key={item.value}>
                            <label className="checkcustom mb-1">
                                <input
                                    onChange={(e) => this.onChange(values, item, e.target.checked)}
                                    type={this.props.isOnceChoice ? 'radio' : 'checkbox'}
                                    name={this.props.name}
                                    value={item.value}
                                    checked={this.shouldChecked(item.value, values)}
                                />
                                {'\u00A0'}{item.label}
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default Checkboxlist;


// WEBPACK FOOTER //
// ./src/views/controls/_Checkboxlist.js